<template>
  <v-sheet class="pa-4">
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :sort-by="['id']"
      sort-desc
      hide-default-footer
    >
    </v-data-table>
  </v-sheet>
</template>

<script>
export default {
  name: 'Employment',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('PROFILE.COMPANY'),
          value: 'company.name'
        },
        {
          text: this.$t('PROFILE.DEPARTMENT'),
          value: 'department'
        },
        {
          text: this.$t('PROFILE.POSITION'),
          value: 'position'
        },
        {
          text: this.$t('PROFILE.WORK_PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('PROFILE.WORK_EMAIL'),
          value: 'email'
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'street'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'city'
        }
      ];
    }
  }
};
</script>
